import type { components } from '@connected/api-client/api.generated';

import { useTranslation } from 'react-i18next';

export type ElectricalInspectionKind = components['schemas']['ElectricalInspectionKind'];

export type ElectricalInspectionKindProps = {
    inspectionKind: ElectricalInspectionKind;
};

export function ElectricalInspectionKind({ inspectionKind }: ElectricalInspectionKindProps) {
    const { t } = useTranslation('elektra');

    return t(`electricalInspectionKind.${inspectionKind}`);
}
